import clsx from 'clsx';
import style from './style.module.scss';

export const Checkbox = ({ id, name, required, label, value = 1, group = false }) => {
    return (
        <div className={style.block}>
            <input className={style.input} type={'checkbox'} name={name} id={id} required={required} value={value} />
            <label
                className={clsx(style.label, !group && required && style.required)}
                htmlFor={id}
                dangerouslySetInnerHTML={{ __html: label }}
            />
        </div>
    );
};

export default Checkbox;
